@if (title() || toolbar().length) {
    <div class="wk-data-table__header">
        <h1 class="wk-data-table__header-title">{{ title() | wkTranslate }}</h1>
        <div class="wk-data-table__header-actions">
            @for (item of toolbar(); track $index) {
                <button-field-pds3 type="primary">
                    <button
                        class="wk-data-table__header__action"
                        type="button"
                        (click)="item.event()"
                        [attr.aria-disabled]="item.disabled ? item.disabled() : false"
                        [disabled]="item.disabled ? item.disabled() : false"
                    >
                        @if (item.icon) {
                            <icon-pds3 flowClass="wk-data-table__header__action-icon" [name]="`wk-icon-${item.icon}`" />
                        }
                        <span>{{ item.title | wkTranslate }}</span>
                    </button>
                </button-field-pds3>
            }
        </div>
    </div>
}
